import { render, staticRenderFns } from "./otherService.vue?vue&type=template&id=3c124664&scoped=true&"
import script from "./otherService.vue?vue&type=script&lang=js&"
export * from "./otherService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c124664",
  null
  
)

export default component.exports